<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h2 class="text-text-neutral-primary text-base font-medium">
            {{ t('charter.whatIsCharterFlight') }}
          </h2>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="px-4 pb-4">
        <div class="bg-background-neutral-secondary space-y-4 rounded-2xl p-4">
          <p class="text-text-neutral-primary font-medium">
            {{ t('charter.howTheyWork') }}:
          </p>
          <div
            v-for="(item, index) in items"
            :key="index"
            class="flex items-start space-x-3"
          >
            <img :src="item.image" alt="" width="24" height="24" />
            <div class="space-y-1">
              <p class="text-text-neutral-primary font-medium">
                {{ item.title }}
              </p>
              <p class="text-text-neutral-primary">{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { FreeBottomSheet, FreeHeader, FreeCloseButton } from 'freedom-shared';

  import { useCharterFlightBottomSheet } from '../model';
  import ticketIcon from './assets/ticket.svg';
  import timeIcon from './assets/time.svg';
  import registrationIcon from './assets/registration.svg';
  import refundIcon from './assets/refund.svg';

  const { name } = useCharterFlightBottomSheet();

  const { t } = useI18n();
  const items = ref([
    {
      title: t('charter.flight'),
      description: t('charter.afterPayment'),
      image: ticketIcon,
    },
    {
      title: t('charter.flightTime'),
      description: t('charter.charterChangeTime'),
      image: timeIcon,
    },
    {
      title: t('charter.registration'),
      description: t('charter.onlineRegistration'),
      image: registrationIcon,
    },
    {
      title: t('charter.refundExchange'),
      description: `${t('charter.cannotRefundExchange')}.`,
      image: refundIcon,
    },
  ]);
</script>

<i18n src="../locales.json" />
